import { render, staticRenderFns } from "./CostElement.vue?vue&type=template&id=01fff427&scoped=true"
import script from "./CostElement.vue?vue&type=script&lang=js"
export * from "./CostElement.vue?vue&type=script&lang=js"
import style0 from "./CostElement.vue?vue&type=style&index=0&id=01fff427&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01fff427",
  null
  
)

export default component.exports